module.exports = __webpack_public_path__ + "img/list.ce560fe2.svg";